import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { useRef, useLayoutEffect, useState, useEffect, useCallback } from 'react'
import time from '../../utils/time'
import colors from '../../theme/colors'
import PropTypes from 'prop-types'
// import country from '../../utils/country'
am4core.useTheme(am4themes_animated);

const styles = {
    chartDiv: () => ({
        width: "100%",
        height: 400
    })
}

const setChartColors = (series/* , bullet */) => {
    return { series/* , bullet */ }
}

const AmLineChart = ({
    resultSet,
    pivotConfig,
    hasScrollbarX,
    hasScrollbarY,
    hasDateAxis,
    showValueLabels,
    showBullets,
    amchartId,
    subqueryProps
}) => {
    const chart = useRef(null);

    let topStoriesPivot = []

    const configureSeries = useCallback((series) => {
        series.strokeWidth = 3;
        series.tooltip.label.maxWidth = 250;
        series.tooltip.label.wrap = true;
        series.tooltip.background.cornerRadius = 10;
        series.tooltip.background.fillOpacity = 0.8;
        series.tooltip.background.strokeOpacity = 0.7;
        // series.smoothing = "monotoneX";
        series.tensionX = 0.77;
        series.smoothing = "monotoneX";
        //series.fillOpacity = 1;
        //series.strokeWidth = 0;
        //series.stacked = true;

        if (showBullets) {
            var bullet = series.bullets.push(new am4charts.CircleBullet());
            configureBullets({ bullet, series });
          }

        if (showValueLabels) {
            let valueLabel = series.bullets.push(new am4charts.LabelBullet());
            configureValueLabels(valueLabel)
        }
    })

    const configureBullets = useCallback(({bullet, series}) => {
        bullet.tooltipText = "[bold]" + (hasDateAxis ? "{dateX}" : "{categoryX}") + ":[/] {valueY}";
        bullet.showTooltipOn = "hover";
        bullet.circle.radius = 6;
        //bullet.circle.fillOpacity = 0.5;
        //bullet.circle.strokeOpacity = 0.5;
        bullet.circle.adapter.add("radius", function (radius, target) {
            if (target.dataItem.valueY == 0) return 0;
            else return radius;
          });

        bullet.circle.fill = series.stroke;
    })

    const configureValueLabels = useCallback((valueLabel) => {
        valueLabel.label.text = '{valueY}';
        valueLabel.label.fontSize = 11;
        valueLabel.label.dy = -15;
        valueLabel.label.dx = 20;
    })

    useLayoutEffect(() => {

        let x = am4core.create(`chartdiv-line-${resultSet.seriesNames()[0]/* .title */}-${amchartId}`, am4charts.XYChart);
        let xAxis

        x.dateFormatter.dateFormat = "dd MMM yyyy";

        const chartData = resultSet.chartPivot()
        const seriesNames = resultSet.seriesNames()
        if (hasDateAxis) {
            xAxis = x.xAxes.push(new am4charts.DateAxis());
            xAxis.renderer.minGridDistance = 30;
            xAxis.renderer.labels.template.rotation = -90;

            xAxis.renderer.labels.template.fontSize = 11
            xAxis.baseInterval = {
                timeUnit: "hour",
                count: 4
            }

            // xAxis.groupData = true;
            //xAxis.dateFormats.setKey('day', 'dd/MM/yyyy')
            //xAxis.periodChangeDateFormats.setKey('day', 'dd/MM/yyyy')
            //xAxis.dateFormats.setKey('week', 'dd/MM/yyyy')
            //xAxis.periodChangeDateFormats.setKey('week', 'dd/MM/yyyy')
        } else {
            xAxis = x.xAxes.push(new am4charts.CategoryAxis());
            xAxis.dataFields.category = "x";
            xAxis.renderer.minGridDistance = 30;
            xAxis.renderer.labels.template.rotation = -90
            xAxis.renderer.labels.template.fontSize = 11
        }

        let valueAxis = x.yAxes.push(new am4charts.ValueAxis());

        seriesNames.map(sItem => {
            let series = x.series.push(new am4charts.LineSeries());
            series.name = sItem.title || sItem.key;
            series.dataFields.valueY = sItem.key;
            series.dataFields.extra = "extra";
            series.dataFields.color = "color";

            if (hasDateAxis) {
                series.dataFields.dateX = "x";
                // series.groupFields.valueY = "high";
            }
            else series.dataFields.categoryX = "x";
            
            configureSeries(series)

            if (showBullets) {
                var bullet = series.bullets.push(new am4charts.CircleBullet());
                configureBullets({ bullet, series })
            }


        })

        if (hasDateAxis) {
            xAxis.renderer.labels.template.events.on("hit", function (ev) {
                var start = ev.target.dataItem.date;
                var end = new Date(start);
                end.setMonth(end.getMonth() + 1);
                xAxis.zoomToDates(start, end);
            });
        }

        if (hasScrollbarX) x.scrollbarX = new am4core.Scrollbar();
        if (hasScrollbarY) x.scrollbarY = new am4core.Scrollbar();

        x.cursor = new am4charts.XYCursor();
        if (seriesNames.length > 0) x.cursor.snapToSeries = resultSet.seriesNames()[0];
        x.cursor.xAxis = xAxis;

        x.data = chartData


        // And, for a good measure, let's add a legend
        x.legend = new am4charts.Legend();
        x.logo.disabled = true
        chart.current = x;

        return () => {
            x.dispose();
        };
    }, []);

    return (
        <div id={`chartdiv-line-${resultSet.seriesNames()[0]/* .title */}-${amchartId}`} style={styles.chartDiv()}></div>
    );
}

AmLineChart.propTypes = {
    hasDateAxis: PropTypes.bool,
    showValueLabels: PropTypes.bool,
    showBullets: PropTypes.bool,
    showScrollbarX: PropTypes.bool,
    showScrollbarY: PropTypes.bool
}

AmLineChart.defaultProps = {
    hasDateAxis: false,
    showValueLabels: false,
    showBullets: false,
    showScrollbarX: false,
    showScrollbarY: false
}

export default AmLineChart;
